/** English strings — sockets + bag + loot clarity (docs/09, docs/03 wave 4). */
export const enHangar = {
  // Pickup notices (secondary to the icon toast)
  'hud.pickupSocket': '+ {name} → socket {n}',
  'hud.pickupBag': '+ {name} → bag',
  'hud.pickupFull': '+ {name} · bag full: swap or scrap at the break',
  'hud.pickupScrap': '{name} → +{n} gems (no room / already owned)',

  // Hangar section captions (secondary to the glyphs)
  'shop.sockets': 'SHIP',
  'shop.bag': 'BAG',
  'shop.shipPower': 'SHIP POWER',
} as const;
